export const hcExtra = {
  reservas: {
    buscar: "Szukaj",
    limpiar: "Wyczyść",
    todas: "Wszystkie",
  },
  nav: {
    volver: "Wróć",
  },
  listingDetail: {
    badgeNew: "Nowe",
  },
  ofertas: {
    precio: "Cena",
  },
  payService: {
    sendRequest: "Wyślij prośbę",
  },
  accountCfg: {
    accountEmail: "E-mail konta",
  },
};
